import { render } from "./PanelAvisosNuevoInput.vue?vue&type=template&id=5727e27e"
import script from "./PanelAvisosNuevoInput.vue?vue&type=script&lang=js"
export * from "./PanelAvisosNuevoInput.vue?vue&type=script&lang=js"
script.render = render

export default script